import Optional from 'optional-js';

/**
 * @ngdoc directive
 * @name kpOnClickOutside
 * @module portaro.directives
 *
 * @restrict A
 * @element ANY
 *
 * @description
 * This directive reacts on click if it is performed outside element
 *
 * @param {expression} kpOnClickOutside Expression is evaluated if directive detects click outside its element.
 * @param {expression=} kpOcoEnabled If the [expression](https://docs.angularjs.org/guide/expression) is truthy/falsy then
 *                                   the evaluating is enabled/disabled respectively.
 * @param {number=} kpOcoMaxDepth Describe max depth for traversing parent elements
 *
 * @example
 * <example module="kpOnClickOutsideExample" name="kpOnClickOutsideExample" frame-no-resize="true">
 <file name="index.html">
 <main ng-controller="exampleController as ec">
 <div class="red" kp-on-click-outside="ec.handler()"></div>
 <div class="blue"></div>
 </main>
 </file>
 <file name="script.js">
 angular.module('kpOnClickOutsideExample', ['portaro.directives'])
 .controller('exampleController', class {
                constructor(){}

                handler() {
                    alert('Handler triggered');
                }
            });
 </file>
 <file name="style.css">
 .red {
            background-color: red;
        }

 .blue {
            background-color: blue;
        }

 .red, .blue {
            width: 30px;
            height: 30px;
        }
 </file>
 * </example>
 */

export default class OnClickOutsideDirective {
    static directiveName = 'kpOnClickOutside';

    restrict = 'A';

    /*@ngInject*/
    constructor($parse, $timeout) {
        this.$parse = $parse;
        this.$timeout = $timeout;
    }

    link($scope, $element, attrs) {
        const maxDepth = Number.parseInt(attrs.kpOcoMaxDepth, 0) || 10;

        const outsideClickHandler = (event) => {
            const enabled = Optional.ofNullable(this.$parse(attrs.kpOcoEnabled)($scope)).orElse(true);

            if (enabled) {
                let counter = 0;
                let currentElement = event.target;
                while (currentElement !== $element[0] && currentElement !== document.documentElement && counter < maxDepth) {
                    counter++;
                    currentElement = currentElement.parentElement;
                }

                if (currentElement === document.documentElement || counter === maxDepth) {
                    const trigger = this.$parse(attrs[OnClickOutsideDirective.directiveName]);
                    $scope.$applyAsync(trigger);
                }
            }
        };

        this.$timeout(() => document.addEventListener('click', outsideClickHandler), 0);

        // Cleanup
        $scope.$on('$destroy', () => {
            document.removeEventListener('click', outsideClickHandler);
        });
    }
}